<template>
  <div id="customer-service" class="customer-service">
    <h3>Report an Issue</h3>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-text-field v-model="title" :counter="10" :rules="titleRules" label="Headline" required></v-text-field>

      <v-text-field v-model="location" :rules="locationRules" label="Location" required></v-text-field>

      <v-textarea
        outline
        name="input-7-4"
        placeholder="How can we help?"
        v-model="content"
        required
      ></v-textarea>

      <v-btn :disabled="!valid" color="indigo white--text" @click="validate">Submit</v-btn>

      <v-btn flat @click.native="cancel">Back</v-btn>
    </v-form>
  </div>
</template>

<script>
export default {
  mounted() {
    this.user_id = this.$store.getters.getAuth.userId;
  },
  data: () => ({
    valid: true,
    coordinator_id: null,
    user_id: "",
    createdAt: "",
    title: "",
    content: "",
    titleRules: [
      v => !!v || "Name is required",
      v => (v && v.length <= 10) || "Name must be less than 10 characters"
    ],
    locationRules: [v => !!v || "Location is required"],
    location: "",
    chat: {}
  }),

  methods: {
    validate() {
      if (this.$refs.form.validate()) {
        this.chat = {
          coordinator_id: 1, // placeholder for now
          user_id: this.user_id,
          createdAt: new Date(),
          title: this.title,
          content: this.content,
          location: this.location
        };

        this.$store
          .dispatch("createChat", this.chat)
          .then(() => {
            this.$router.push("home");
          })
          .catch(error => {
            this.showError(error);
          });

        // need to figure out how to send email
        this.showSuccess(`Successfully notified us`);
        this.$router.push("home");
      }
    },
    cancel() {
      this.$router.push("home");
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    }
  }
};
</script>

<style scoped>
.customer-service {
  width: 100%;
  padding: 20px;
}
</style>
